namespace $.$$ {

	$mol_style_define( $shm_hitalama_process_logs_row, {

		display: 'flex',
		flex: {
			direction: 'column',
		},
		gap: $mol_gap.text,

		Head: {
			display: 'flex',
			flex: {
				wrap: 'wrap',
			},
			align: {
				items: 'center',
			},
			gap: $mol_gap.text,
			padding: $mol_gap.text,
			background: {
				color: $mol_theme.card,
			},
			border: {
				radius: $mol_gap.round,
			},
		},

		Status: {
			padding: {
				top: '.15rem',
				bottom: '.15rem',
				left: '.45rem',
				right: '.45rem',
			},
			border: {
				radius: $mol_gap.round,
			},
			background: {
				color: $mol_theme.line,
			},
			font: {
				size: '.75rem',
				weight: 600,
			},
			textTransform: 'uppercase',
		},

		Name: {
			flex: {
				grow: 1,
			},
			font: {
				family: 'monospace',
			},
			wordBreak: 'break-all',
		},

		Started: {
			flex: {
				shrink: 0,
			},
		},

		Duration: {
			flex: {
				shrink: 0,
			},
			color: $mol_theme.shade,
			font: {
				family: 'monospace',
				size: '.85rem',
			},
		},

		Children: {
			margin: {
				left: $mol_gap.block,
			},
			padding: {
				left: $mol_gap.block,
			},
			border: {
				left: {
					width: '1px',
					style: 'solid',
					color: $mol_theme.line,
				},
			},
			gap: $mol_gap.text,
		},

	} )

}
